import type { JSX } from 'react';
import {
  FundAccountButton,
  FundAccountCallout,
  FundAccountHTMLButton,
} from '@/shared/components/dashboards/FundAccount';
import { useDepositAssetModalStore } from './Dashboard/DepositAssetModal/DepositAssetModal';
import { useStateChainAccount } from '../hooks/useStateChainAccount';

const useAccountIsEmpty = () => {
  const { totalBalance } = useStateChainAccount();
  return totalBalance !== null ? totalBalance === 0 : undefined;
};

export const LpFundAccountButton = ({
  skipFundingCheck,
  ...props
}: React.ComponentProps<typeof FundAccountButton> & {
  skipFundingCheck?: boolean;
}): JSX.Element => {
  const { openDepositModal } = useDepositAssetModalStore();
  const accountIsEmpty = useAccountIsEmpty();
  return (
    <FundAccountButton
      {...props}
      accountIsEmpty={accountIsEmpty && !skipFundingCheck} // this check added to skip rendering DFC modal from borrow button
      onDeposit={openDepositModal}
    />
  );
};

export const LpFundAccountCallout = (): JSX.Element => {
  const { openDepositModal } = useDepositAssetModalStore();
  const accountIsEmpty = useAccountIsEmpty();
  return (
    <FundAccountCallout accountIsEmpty={accountIsEmpty} onFundAccount={() => openDepositModal()} />
  );
};

export const LpFundAccountHTMLButton = (
  props: React.ComponentProps<typeof FundAccountHTMLButton>,
): JSX.Element => {
  const { openDepositModal } = useDepositAssetModalStore();
  const accountIsEmpty = useAccountIsEmpty();
  return (
    <FundAccountHTMLButton
      {...props}
      accountIsEmpty={accountIsEmpty}
      onDeposit={openDepositModal}
    />
  );
};
